import React from "react";
import {useTranslate} from "react-admin";
import {CustomAccordion, fullNameText} from "../../../components";
import {OrderContent} from "./orderContent";
import {makeStyles} from "@material-ui/core";
import {ROLE_USER} from "../../user/constants";
import {diffInMinutes, prettyTimeString, timeString} from "../../activity/utils";


const useStyles = makeStyles({
    title: {
        margin: '-0.5px',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        padding: '1px',
        color: 'rgb(255,255,255)'
    },
});

export const getEventContent = (permissions, location) => {
    return eventInfo => {
        return <Event
            {...eventInfo?.event?.extendedProps}
            calendarApi={eventInfo.view.getCurrentData().calendarApi}
            permissions={permissions}
            location={location}
        />
    }
};


const Event = ({orders, location, permissions, calendarApi, assigneeId, realizationDate}) => {
    const translate = useTranslate();
    const classes = useStyles();
    if (!orders || orders.length === 0) return <div/>;

    const {firstStart, lastEnd} = orders.reduce((acc, {startRealizationDateTime: s, endRealizationDateTime: e}) => {
        if (s) acc.firstStart = !acc.firstStart || s < acc.firstStart ? s : acc.firstStart;
        if (e) acc.lastEnd = !acc.lastEnd || e > acc.lastEnd ? e : acc.lastEnd;
        return acc;
    }, {firstStart: null, lastEnd: null});

    const employeeDetails = <div>
        <div style={{display: "grid", gridTemplateColumns: "auto 1fr", gap: "8px", rowGap: "0px",}}>
            <span>{translate('resources.employees.fields.startWorkingDay')}:</span>
            <strong>{timeString(firstStart) || '?'}</strong>
            <span>{translate('resources.employees.fields.endWorkingDay')}:</span>
            <strong>{timeString(lastEnd) || '?'}</strong>
            <span>{translate('resources.employees.fields.workingDay')}:</span>
            <strong>{prettyTimeString(diffInMinutes(firstStart, lastEnd))}</strong>
        </div>
    </div>

    const orderContent = <div
        className='droppable-element'
        realizationDate={realizationDate}
        assigneeId={assigneeId}
    >
        {/*{orders.map(o => {*/}
        {/*    return <OrderContent*/}
        {/*        permissions={permissions}*/}
        {/*        location={location}*/}
        {/*        order={o}*/}
        {/*        calendarApi={calendarApi}*/}
        {/*    />*/}
        {/*})}*/}
        {[...orders]
            .sort((a, b) => {
                const dateA = a.startRealizationDateTime;
                const dateB = b.startRealizationDateTime;
                if (dateA === null && dateB === null) return 0;
                if (dateA === null) return 1;
                if (dateB === null) return -1;

                return new Date(dateA) - new Date(dateB);
            })
            .map(o => {
                return (
                    <OrderContent
                        permissions={permissions}
                        location={location}
                        order={o}
                        calendarApi={calendarApi}
                    />
                );
            })
        }
    </div>

    return permissions === ROLE_USER ? orderContent :

        <CustomAccordion
            className='droppable-container'
            title={fullNameText(translate('resources.orders.fields.noAssignee'))(orders[0]?.assignee)}
            summaryTooltip={employeeDetails}
            detailsClassName={classes.details}
            summaryProps={{style: {minHeight: '30px', maxHeight: '30px', width: '100%'}}}
            square
            defaultExpanded
            TransitionProps={{unmountOnExit: false}}
        >
            {orderContent}
        </CustomAccordion>
};
